import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import './SingleProject.css';

function SingleProject({ project, index }) {
    return (
        <div className={`doppelrand-shell project-card-shell ${index % 2 !== 0 ? 'reverse' : ''}`}>
            <div className="doppelrand-core project-card-core">
                {/* Visual Image Screen */}
                <div className="project-image-box">
                    <img src={project.image} alt={project.projectName} className="project-img" />
                    <div className="project-img-overlay"></div>
                </div>

                {/* Content Info */}
                <div className="project-content-box">
                    <div className="project-header">
                        <span className="project-number">0{index + 1}</span>
                        <h3 className="project-title">{project.projectName}</h3>
                    </div>

                    <p className="project-description">{project.projectDesc}</p>

                    <div className="project-tags">
                        {project.tags.map((tag) => (
                            <span key={tag} className="project-tag-pill">{tag}</span>
                        ))}
                    </div>

                    <div className="project-cta-group">
                        <a 
                          href={project.demo} 
                          target="_blank" 
                          rel="noreferrer" 
                          className="cta-pill"
                        >
                            <span>Live Application</span>
                            <div className="icon-wrapper">
                                <FaExternalLinkAlt style={{ fontSize: '0.8rem' }} />
                            </div>
                        </a>

                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SingleProject;
